import type { CookiesPageStory } from '@/services/storyblok/storyblok'
import { StoryblokComponent, storyblokEditable } from '@storyblok/react'
import { main } from '../PageBlock.css'

type Props = {
  blok: CookiesPageStory['content']
}

export const CookiesPageBlock = ({ blok }: Props) => {
  return (
    <main className={main} {...storyblokEditable(blok)} data-header-mode="sticky">
      {blok.body.map((nestedBlock) => (
        <StoryblokComponent blok={nestedBlock} key={nestedBlock._uid} />
      ))}
    </main>
  )
}
CookiesPageBlock.blockName = 'cookiesPage'
